import { initialState, State, Action } from '../store/store';

export const updateScore = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    userBehaviour: {
      ...state.userBehaviour,
      score: {
        ...state.userBehaviour.score,
        [data.id]: data.score,
      },
    },
  };
};
